import type { UserPreferencesHydraItem } from "@verbleif/lib/src/composables/Api/Type/UserPreferences/user_preferences.interface";
import { api } from "../../Api/api";
import { effectiveUserPreferenceUrl } from "./useUserPreferenceEndpoints";

/**
 * The effective preferences of a user at a location, or across locations without one, as a request of its own. It
 * skips the query cache on purpose: the cache joins a request that is still running, and that one may have started
 * before a change was stored, so a refetch right after a save would get the answer from before it.
 */
export async function requestEffectiveUserPreferences(
  userId: number,
  locationId: number | null,
  signal?: AbortSignal,
): Promise<UserPreferencesHydraItem> {
  const url = locationId !== null
    ? effectiveUserPreferenceUrl(userId, locationId)
    : "/api/user_preferences/me";
  const { data } = signal
    ? await api.get<UserPreferencesHydraItem>(url, { signal })
    : await api.get<UserPreferencesHydraItem>(url);

  return data;
}
